import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import UICard from "./UICard";

const UITableSection = ({
  title,
  subtitle,
  headerActions,
  toolbar,
  children,
  footer,
  cardSx,
  dense = false,
  contentSx,
}) => {
  return (
    <UICard
      disableContentPadding
      cardSx={{
        borderRadius: dense ? 3 : undefined,
        boxShadow: dense ? "0 10px 30px rgba(17, 24, 39, 0.05)" : undefined,
        ...cardSx,
      }}
    >
      {(title || subtitle || headerActions) ? (
        <>
          <Stack
            direction={{ xs: "column", md: "row" }}
            alignItems={{ xs: "flex-start", md: "center" }}
            justifyContent="space-between"
            spacing={dense ? 1.5 : 2}
            sx={{ px: dense ? 2.5 : 3, py: dense ? 2 : 3 }}
          >
            <Box>
              {title ? (
                <Typography variant="h6" color="text.primary">
                  {title}
                </Typography>
              ) : null}
              {subtitle ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: dense ? 0.35 : 0.75 }}
                >
                  {subtitle}
                </Typography>
              ) : null}
            </Box>
            {headerActions ? (
              <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
                {headerActions}
              </Stack>
            ) : null}
          </Stack>
          <Divider />
        </>
      ) : null}

      {toolbar ? (
        <>
          <Box sx={{ px: dense ? 2.5 : 3, py: dense ? 1.5 : 2.5 }}>{toolbar}</Box>
          <Divider />
        </>
      ) : null}

      <Box sx={contentSx}>{children}</Box>

      {footer ? (
        <>
          <Divider />
          <Box sx={{ px: dense ? 2.5 : 3, py: dense ? 1.25 : 2 }}>{footer}</Box>
        </>
      ) : null}
    </UICard>
  );
};

export default UITableSection;
